import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import StatusBadge from "@/components/StatusBadge";
import { toast } from "sonner";

export default function AdminUsers() {
  const [role, setRole] = useState("staff");
  const [items, setItems] = useState([]);
  const load = () => api.get(`/admin/users?role=${role}`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [role]);
  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/users/${id}/status?status=${status}`); toast.success("Updated"); load(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Users</h1>
        <Select value={role} onValueChange={setRole}>
          <SelectTrigger className="w-40 h-11" data-testid="admin-role-filter"><SelectValue/></SelectTrigger>
          <SelectContent>
            <SelectItem value="staff">Staff</SelectItem>
            <SelectItem value="company">Companies</SelectItem>
            <SelectItem value="admin">Admins</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="card-tactile overflow-hidden">
        <div className="grid grid-cols-12 px-4 py-3 border-b border-slate-200 bg-slate-50 label-caps">
          <div className="col-span-4">Name</div>
          <div className="col-span-4">Email</div>
          <div className="col-span-2">Status</div>
          <div className="col-span-2 text-right">Actions</div>
        </div>
        {items.map((u) => (
          <div key={u.id} data-testid={`admin-user-${u.id}`} className="grid grid-cols-12 px-4 py-3 border-b border-slate-100 last:border-0 items-center text-sm">
            <div className="col-span-4 font-semibold text-slate-900 truncate">{u.first_name} {u.last_name}</div>
            <div className="col-span-4 text-slate-700 truncate">{u.email}</div>
            <div className="col-span-2"><StatusBadge status={u.status} /></div>
            <div className="col-span-2 flex justify-end gap-1">
              {u.status !== "active" && <Button size="sm" onClick={()=>setStatus(u.id, "active")} className="bg-emerald-600 hover:bg-emerald-700 h-8" data-testid={`approve-${u.id}`}>Approve</Button>}
              {u.status !== "suspended" && <Button size="sm" variant="outline" onClick={()=>setStatus(u.id, "suspended")} className="h-8 text-red-600 border-red-200" data-testid={`suspend-${u.id}`}>Suspend</Button>}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-6 text-center text-slate-500">No users.</div>}
      </div>
    </div>
  );
}
